export function getRepairOrderPrintHtml({
  result,
  fields,
  toTitleCase,
  moment,
  qrCode,
}) {
  return `
    <html>
      <head>
        <title>Repair Order - ${result.repairOrder || 'Unknown'}</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            background: #fff;
            margin: 0;
            padding: 0;
            font-size: 9px;
          }
            .logo {
                height: 40px;
                object-fit: contain;
              }
          .print-container {
            margin: 10px auto;
            padding: 8px 8px 12px 8px;
            background: #fff;
            border: 1px solid #ccc;
            max-width: 700px;
          }
          .print-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
          }
          .print-title {
            color: #002EE5;
            font-size: 18px;
            font-weight: bold;
            margin: 0;
            margin-top: 20px;
            letter-spacing: 1px;
          }
          .table-qr-code {
            display: flex;
            margin-top: 10px;
          }
          .repair-table {
            width: 100%;
            border-collapse: collapse;
          }
          .repair-table th, .repair-table td {
            padding: 4px 6px;
            font-size: 9px;
          }
          .repair-table th {
            background: #050533;
            color: #fff;
            text-align: left;
            font-weight: bold;
            width: 120px;
            border-right: 1px solid #fff;
          }
          .repair-table td {
            background: #f4f4f4;
            color: #222;
            border-left: 1px solid #e0e0e0;
            word-break: break-word;
          }
          .additional-entries {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          .additional-entries th, .additional-entries td {
            padding: 4px 6px;
            font-size: 9px;
          }
          .additional-entries th {
  background: #050533;
  color: #fff;
  text-align: left;
  font-weight: bold;
  border-right: 1px solid #fff;
}

.additional-entries th:first-child,
.additional-entries td:first-child {
  width: 30px;
  text-align: center;
}
          .additional-entries td {
            background: #f4f4f4;
            color: #222;
            border-left: 1px solid #e0e0e0;
            word-break: break-word;
          }
          .entry-card {
            margin-bottom: 8px;
            border: 1px solid #e0e0e0;
            background: #fafbfc;
            padding: 6px 8px;
            page-break-inside: avoid;
          }
          .entry-card h3 {
            font-size: 10px;
            color: #050533;
            margin: 0 0 4px 0;
          }
          .entry-table th, .entry-table td {
            padding: 3px 5px;
            font-size: 9px;
          }
          .entry-table th {
            background: #050533;
            color: #fff;
            width: 90px;
            border-right: 1px solid #fff;
          }
          .entry-table td {
            background: #f4f4f4;
            color: #222;
            border-left: 1px solid #e0e0e0;
            word-break: break-word;
          }
          @media print {
            html, body {
              width: 100%;
              height: 100%;
              margin: 0;
              padding: 0;
              zoom: 0.85;
            }
            .print-container {
              box-shadow: none;
              border: none;
              margin: 0;
              padding: 0;
              max-width: 100vw;
            }
            .print-header, .print-title, .repair-table, .additional-entries, .entry-card, .entry-table {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <div class="print-header">
            <div class="print-title">BENCH REPAIR LOG</div>
            <img class="logo" src="https://brandcentral.brightstarlottery.com/media/mfultswy/brightstar_logo_tm_white_background.png?width=900&height=327&format=webp&quality=85&metadata=none&sharpen=5&v=1dbd657f6023440" alt="Logo" />
          </div>
          <div class="table-qr-code">
            <table class="repair-table">
              <tbody>
                ${fields
                  .filter(({ key }) =>
                    [
                      'jurisdiction',
                      'repairOrder',
                      'dateTime',
                      'openCase',
                      'caseNumber',
                      'oem',
                      'rrfRepair',
                    ].includes(key)
                  )
                  .map(
                    ({ label, key, format }) => `
                      <tr>
                        <th>${label}</th>
                        <td>${
                          format === 'date'
                            ? result.repairOrderDetails[key]
                              ? moment(result.repairOrderDetails[key]).format(
                                  'YYYY-MM-DD'
                                )
                              : 'N/A'
                            : result.repairOrderDetails[key]
                            ? result.repairOrderDetails[key]
                            : 'N/A'
                        }</td>
                      </tr>
                    `
                  )
                  .join('')}
              </tbody>
            </table>
            <img src="${qrCode}" alt="QR-Code" />
          </div>
         ${
           result.entries && result.entries.length > 0
             ? `
            <table class="additional-entries">
              <thead>
                <tr>
                  <th>#</th> 
                  <th>Product</th>
                  <th>Serial Number</th>
                  <th>Asset Tag</th>
                  <th>Item Number</th>
                  <th>Start Date</th>
                  <th>Completion Date</th>
                </tr>
              </thead>
              <tbody>
                ${result.entries
                  .map((entry, index) => {
                    const itemNumber =
                      entry.pcb ||
                      entry.reader ||
                      entry.burster ||
                      entry.printer ||
                      entry.terminal ||
                      entry.peripherals ||
                      entry.powerSupply ||
                      entry.billAcceptor ||
                      entry.displayMonitors ||
                      entry.commDevice ||
                      'N/A';

                    return `
                      <tr>
                        <td>${index + 1}</td>
                        <td>${entry.product || 'N/A'}</td>
                        <td>${entry.serialNumber || 'N/A'}</td>
                        <td>${entry.assetTag || 'N/A'}</td>
                        <td>${entry.itemNumber}</td>
                        <td>${entry.startDate ? moment(entry.startDate).format('MM/DD/YYYY') : 'N/A'}</td>
                        <td>${entry.completionDate ? moment(entry.completionDate).format('MM/DD/YYYY') : 'N/A'}</td>
                      </tr>
                    `;
                  })
                  .join('')}
              </tbody>
            </table>
            `
             : ''
         }
        </div>
      </body>
    </html>
  `;
}
